module.exports = __webpack_public_path__ + "static/media/termo-lojista-icon.164a4e38.JPG";